import { defaultHarmonyProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/harmony/default-constants';

export const VIPER_SWAP_HARMONY_CONTRACT_ADDRESS = '0xf012702a5f0e54015362cBCA26a26fc90AA832a3';

export const VIPER_SWAP_HARMONY_PROVIDER_CONFIGURATION = defaultHarmonyProviderConfiguration;
